import request from '@/utils/request'

// 量表列表
// export function gaugeList(data) {
//   return request({
//     url: '/health-doctor/cure/survey/personal/list',
//     method: 'get',
//     params: data
//   })
// }

export function gaugeList(data) {
  return request({
    url: '/health-doctor/cure/survey/page/list',
    method: 'get',
    params: data
  })
}
// 量表详情
export function gaugeDetailApi(data) {
  return request({
    url: '/health-user/user/survey/detail',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  })
}
// 量表详情
export function gaugeDetailApiNew(data) {
  return request({
    url: '/health-doctor/surveynew/sendDetail',
    method: 'get',
    params: data
  })
}
// 获取图片量表详情
export function getsurveyPictureDetail(data) {
  return request({
    url: '/health-doctor/cure/survey/detail',
    method: 'get',
    params: data
  })
}
